module.exports = "<div class=\"section group\">\n  <div ng-repeat=\"region in vm.regions\" class=\"col col-1-{{vm.columns || 3}}\">\n    <news12-button on-select=\"vm.select(region)\" on-keydown=\"vm.keyDown(event, region, $index)\" ng-class=\"{'focusable-first': $index == 0, selected: region.abbr === vm.selected.abbr }\">{{region.name}}</news12-button>\n  </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/regionSelection/regionSelection.html
 ** module id = 105
 ** module chunks = 0
 **/